import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Common/Interceptors/AxiosConfig";

const initialState = {
  errors: null,
  isLoading: false,
  jobsData: [],
  allJobsData: [],
  myJobsPostsData: [],
  detailedJobPostsData: []
};


const JobsSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setJobsData: (state, action) => {
      state.jobsData = action.payload;
    },
    setAllJobsData: (state, action) => {
      state.allJobsData = action.payload;
    },
    setMyJobsPostsData: (state, action) => {
      state.myJobsPostsData = action.payload;
    },
    // ✅ Fixed function name
    setDetailedJobPostsData: (state, action) => {
      state.detailedJobPostsData = action.payload;
    }
  },
});


export const addJob = (jobdata) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    let URL = "/job";
    const response = await axiosInstance.post(URL, jobdata);
    const { status } = response?.data || {};

    if (status === "success") {
      dispatch(setJobsData(response?.data?.data));
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong.";

    dispatch(
      setErrors({
        status: error?.response?.status,
        message: errorMsg,
      })
    );
  }
  dispatch(setLoading(false));
};

export const allJobs = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    let URL = "/job/all";
    const response = await axiosInstance.get(URL);
    const { status, data } = response?.data || {};
    if (status === "success") {
      dispatch(setAllJobsData(data));
    }
  } catch (error) {
    
    const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong.";

    dispatch(
      setErrors({
        status: error?.response?.status,
        message: errorMsg,
      })
    );
  }
};



export const myJobPosts = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    let URL = "/job/myCreatedJobs";
    const response = await axiosInstance.get(URL);
    const { status, data } = response?.data || {};
    if (status === "success") {
      dispatch(setMyJobsPostsData(data));
    }
  } catch (error) {
    
    const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong.";

    dispatch(
      setErrors({
        status: error?.response?.status,
        message: errorMsg,
      })
    );
  }
};



export const jobPostDetails = (workId) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    let URL = `/job/${workId}`;
    const response = await axiosInstance.get(URL);
    const { status, data } = response?.data || {};
    
    if (status === "success") {
      
      // ✅ Now this will work
      dispatch(setDetailedJobPostsData(data));
    }
  } catch (error) {
    const errorResponse = error?.response;
    dispatch(setErrors({
      status: errorResponse?.status,
      statusText: errorResponse?.statusText,
      message: errorResponse?.data?.message || error.message || "Something went wrong."
    }));
  }
  dispatch(setLoading(false));
};


export const { setErrors, setLoading, setJobsData, setAllJobsData, setMyJobsPostsData, setDetailedJobPostsData } = JobsSlice.actions;
export default JobsSlice.reducer;
